import { StatusTone, TONE_CLASSES } from '../../utils/statusMeta';
export type Criterion = {id:string;text:string;required:boolean;allow_not_applicable:boolean};
export type AcceptanceCriteria = {version:number;status:string;period_mode?:string;instructions:string;criteria:Criterion[]};
export type Assessment = {
 recommendation:'recommend_approve'|'recommend_reject'|'uncertain';
 human_approval_required:true;summary:string;
 checks:{criterion_id:string;outcome:'met'|'not_met'|'unknown'|'not_applicable';explanation:string;evidence:{page:number;quote:string}[]}[];
};
export type AssessmentStatus = {document_id:string;ai_status:string;reason:string;assessment:Assessment|null;criteria:AcceptanceCriteria|null;criteria_hash:string|null;created_at:string|null};
export function acceptanceCriteria(value:unknown):AcceptanceCriteria|null {
 if(!value||typeof value!=='object')return null;
 const v=value as AcceptanceCriteria;
 return typeof v.instructions==='string'&&Array.isArray(v.criteria)&&v.criteria.every(c=>c&&typeof c.id==='string'&&typeof c.text==='string'&&typeof c.required==='boolean'&&typeof c.allow_not_applicable==='boolean')?v:null;
}
export function assessmentLabel(row:AssessmentStatus|null|undefined):string {
 if(row?.reason==='service_waiting')return 'Esperando servicio · Reintento automático';
 if(row?.assessment)return {recommend_approve:'Recomienda aprobar',recommend_reject:'Recomienda rechazar',uncertain:'No puede concluir'}[row.assessment.recommendation];
 if(row?.reason==='criteria_missing')return 'Sin criterios de aceptación';
 if(row?.reason==='assessment_pending')return 'Evaluación pendiente';
 if(row?.reason==='assessment_queued')return 'Evaluación en cola';
 if(row?.reason==='assessment_running')return 'Evaluando criterios…';
 if(row?.reason==='assessment_failed')return 'Evaluación no disponible';
 return 'Sin evaluación de criterios';
}
export type CheckOutcome = Assessment['checks'][number]['outcome'];
/** Text label + status tone for each criterion outcome, so findings never rely on color alone. */
export const OUTCOME_META: Record<CheckOutcome, { label: string; tone: StatusTone }> = {
 met:{label:'Cumple',tone:'success'},
 not_met:{label:'No cumple',tone:'danger'},
 unknown:{label:'Por confirmar',tone:'warning'},
 not_applicable:{label:'No aplica',tone:'neutral'},
};
export const outcomeBadgeClass=(outcome:CheckOutcome)=>`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${TONE_CLASSES[OUTCOME_META[outcome].tone]}`;
